export const externalApiPathRegex = /(\/external-api-[^/]+)\//;
